import { DEFAULT_LOTSIZE_STATE, DEFAULT_ONE_PIP, DEFAULT_STOP_LOSS, OPERATIONS, STOPLOSS_TYPES } from "../../lib/constants";
import { genStopLoss, getInstrumentBySymbolName, getLatestDepositCurrencies, getLatestInstruments, getPipsByStopLoss, setLotsizeState } from "../../lib/funcs";
import { updateOnePips, updateUnitsOfOneLot } from "../shared/funcs";
import { LotsizeActionTypes, UPDATE_LOTSIZE_FIELDS } from "./actionTypes";

const updatePrices = (changed: Partial<ILotsizeFields>, updated: ILotsizeFields) => {
  let pInstrument: IInstrument | null = null;
  if (changed.hasOwnProperty("selectedInstrument") || changed.hasOwnProperty("selectedDepositCurrency") || !updated.priceInstrument) {
    if (
      !updated.selectedInstrument ||
      !updated.selectedDepositCurrency ||
      updated.selectedInstrument.endsWith(`/${updated.selectedDepositCurrency}`)
    ) {
      updated.priceInstrument = undefined;
    } else {
      const selectedInstrumentObj = getInstrumentBySymbolName(updated.selectedInstrument);
      if (updated.selectedInstrument.startsWith(`${updated.selectedDepositCurrency}/`)) {
        updated.priceInstrument = { SymbolName: selectedInstrumentObj.SymbolName, operation: OPERATIONS.MUL };
      } else {
        pInstrument = selectedInstrumentObj;
        let operation = OPERATIONS.MUL;
        getLatestInstruments().forEach((i: IInstrument) => {
          if (
            updated.selectedInstrument.endsWith(`/${i.QuoteCurrency}`) &&
            updated.selectedDepositCurrency === i.BaseCurrency
          ) {
            pInstrument = i;
            operation = OPERATIONS.MUL;
          }
          if (
            i.QuoteCurrency === updated.selectedDepositCurrency &&
            updated.selectedInstrument.endsWith(`/${i.BaseCurrency}`)
          ) {
            pInstrument = i;
            operation = OPERATIONS.DIV;
          }
        });
        if (pInstrument) {
          updated.priceInstrument = { SymbolName: pInstrument.SymbolName, operation };
        }
      }
    }
  }

  if(((changed.hasOwnProperty("selectedInstrument") || changed.hasOwnProperty("selectedDepositCurrency")) && !changed.hasOwnProperty("unitsOfOneLot")) || changed.priceUpdatedAt === 0) {
    pInstrument = pInstrument || getInstrumentBySymbolName(updated.selectedInstrument);
    updated.price = Number(pInstrument.SymbolRate.toFixed(6)).toString();
  }

  return updated;
}

const updateDepositableCurrencies = (changed: Partial<ILotsizeFields>, updated: ILotsizeFields) => {
  if (!changed.selectedInstrument && !changed.selectedDepositCurrency && updated.depositableCurrencies.length) return updated;

  let depositableCurrencies: IDepositCurrency[] = [];
  const depositCurrencies = getLatestDepositCurrencies();
  const instruments = getLatestInstruments();
  if (updated.selectedInstrument && depositCurrencies.length && instruments.length) {
    const filteredInstruments = instruments.filter(
      (ins) =>
        updated.selectedInstrument.endsWith(`/${ins.BaseCurrency}`) ||
        updated.selectedInstrument.endsWith(`/${ins.QuoteCurrency}`)
    );
    depositableCurrencies = depositCurrencies.filter(
      (dc) =>
        filteredInstruments.some(
          (fi) =>
            fi.BaseCurrency === dc.GlobalCurrencyName ||
            fi.QuoteCurrency === dc.GlobalCurrencyName
        )
    )
  }
  if (!depositableCurrencies.some(dc => dc.GlobalCurrencyName === updated.selectedDepositCurrency)) {
    updated.selectedDepositCurrency = depositableCurrencies[0]?.GlobalCurrencyName;
  }
  updated.depositableCurrencies = depositableCurrencies;

  return updated;
}

const updateOpenAndClosePrice = (changed: Partial<ILotsizeFields>, updated: ILotsizeFields) => {
  if ((changed.selectedInstrument || changed.price) && updated.stopLossType === STOPLOSS_TYPES.CURRENCY) {
    const selectedInstrumentObj = getInstrumentBySymbolName(updated.selectedInstrument);
    const price = selectedInstrumentObj?.SymbolRate || "1.0";
    const pips = getPipsByStopLoss(updated.openPrice, typeof updated.onePip === "undefined" ? DEFAULT_ONE_PIP : updated.onePip, updated.stopLoss).toString();
    updated.openPrice = price.toString();
    updated.stopLoss = Number(genStopLoss(Number(price), Number(updated.onePip), Number(pips)).toFixed(6)).toString();
  }
  return updated;
}

const lotsizeReducer = (state = DEFAULT_LOTSIZE_STATE, action: LotsizeActionTypes): ILotsizeFields => {
  switch (action.type) {
    case UPDATE_LOTSIZE_FIELDS: {

      let changed = action.payload;
      let updated = { ...state, ...changed, priceUpdatedAt: Math.max(state.priceUpdatedAt || 0, changed.priceUpdatedAt || 0) };

      updated = updatePrices(changed, updated) as ILotsizeFields;
      updated = updateOnePips(changed, updated) as ILotsizeFields;
      updated = updateUnitsOfOneLot(changed, updated) as ILotsizeFields;
      updated = updateDepositableCurrencies(changed, updated) as ILotsizeFields;
      updated = updateOpenAndClosePrice(changed, updated);

      setLotsizeState(updated);

      return updated;
    }
    default:
      return state;
  }
};


export default lotsizeReducer;
